if (!customElements.get('shipping-date-component')) {
  class ShippingDateComponent extends HTMLElement {
    connectedCallback() {
      this.config = [];
      this.defaults = {
        production_days: parseInt(this.dataset.defaultDays) || 2,
        cutoff_hour: parseInt(this.dataset.defaultCutoff) || 15
      };
      this.freeShippingThreshold = parseInt(this.dataset.freeShippingThreshold) || 0;
      this.currentVariantPrice = parseInt(this.dataset.variantPrice) || 0;
      this.currentSku = this.dataset.initialSku || '';

      try { this.config = JSON.parse(this.dataset.shippingConfig || '[]'); } catch (e) {}

      // Parse variants for fallback variant lookup
      this.productVariants = [];
      try { this.productVariants = JSON.parse(this.dataset.variants || '[]'); } catch (e) {}
      if (!this.currentSku && this.productVariants.length) {
        this.currentSku = this.productVariants[0].sku || '';
      }

      // DOM refs
      this.dateRange = this.querySelector('[data-delivery-date]');
      this.cutoffMessage = this.querySelector('[data-cutoff-message]');
      this.freeShippingWrapper = this.querySelector('[data-free-shipping-wrapper]');

      // Subscribe to variant changes via Paletia pub/sub
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          if (e.data?.variant) {
            this.currentSku = e.data.variant.sku || '';
            this.currentVariantPrice = e.data.variant.price || 0;
            this.calculate();
            this.updateFreeShipping();
          }
        });
      }

      // Listen for quantity changes
      var qtyInput = document.querySelector('input[name="quantity"]');
      if (qtyInput) {
        this._qtyHandler = () => this.updateFreeShipping();
        qtyInput.addEventListener('change', this._qtyHandler);
        qtyInput.addEventListener('input', this._qtyHandler);
      }

      this.calculate();
      this.updateFreeShipping();
    }

    disconnectedCallback() {
      if (this.unsub) this.unsub();
      var qtyInput = document.querySelector('input[name="quantity"]');
      if (qtyInput && this._qtyHandler) {
        qtyInput.removeEventListener('change', this._qtyHandler);
        qtyInput.removeEventListener('input', this._qtyHandler);
      }
    }

    getRule() {
      if (!this.currentSku) return this.defaults;
      for (var r of this.config) {
        try {
          if (new RegExp(r.sku_pattern, 'i').test(this.currentSku)) return r;
        } catch (e) {}
      }
      return this.defaults;
    }

    /**
     * Add production days (Monday-Friday only).
     * Start day counts as day 1 (matches Horizon logic).
     */
    addProductionDays(start, days) {
      if (days === 0) return new Date(start);
      var d = new Date(start);
      var counted = 1; // Start day is day 1
      while (counted < days) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) counted++;
      }
      return d;
    }

    /** Get next delivery day (Monday-Saturday, skip Sunday) */
    getNextDeliveryDay(start) {
      var d = new Date(start);
      d.setDate(d.getDate() + 1);
      if (d.getDay() === 0) d.setDate(d.getDate() + 1); // Skip Sunday
      return d;
    }

    /** Get next production day (Monday-Friday) */
    getNextProductionDay(start) {
      var d = new Date(start);
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow === 0) d.setDate(d.getDate() + 1);      // Sunday → Monday
      else if (dow === 6) d.setDate(d.getDate() + 2);  // Saturday → Monday
      return d;
    }

    calculate() {
      var rule = this.getRule();
      var prodDays = rule.production_days || this.defaults.production_days;
      var cutoff = rule.cutoff_hour || this.defaults.cutoff_hour;

      // Current time in Amsterdam
      var now = new Date();
      var ams = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      var h = ams.getHours();
      var dow = ams.getDay();

      // Determine production start
      var productionStart;
      if (dow >= 1 && dow <= 5 && h < cutoff) {
        productionStart = new Date(ams); // Today (weekday before cutoff)
      } else {
        productionStart = this.getNextProductionDay(ams);
      }

      // Add production days (Mon-Fri only)
      var productionEnd = this.addProductionDays(productionStart, prodDays);

      // Ship same day production ends, deliver next day (Mon-Sat)
      var deliveryDate = this.getNextDeliveryDay(productionEnd);

      // German domain: +1 delivery day
      var canonical = document.querySelector('link[rel="canonical"]')?.getAttribute('href') || window.location.href;
      if (canonical.includes('.de')) {
        deliveryDate = this.getNextDeliveryDay(deliveryDate);
      }

      // Format and display
      var loc = document.documentElement.lang || 'nl';
      var opts = { weekday: 'short', day: 'numeric', month: 'short' };

      if (this.dateRange) {
        this.dateRange.textContent = deliveryDate.toLocaleDateString(loc, opts);
      }

      // Show/hide cutoff message
      if (this.cutoffMessage) {
        this.cutoffMessage.style.display = (h < cutoff && dow >= 1 && dow <= 5) ? '' : 'none';
      }
    }

    updateFreeShipping() {
      if (!this.freeShippingWrapper || !this.freeShippingThreshold) return;

      var qtyInput = document.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var total = this.currentVariantPrice * qty;

      this.freeShippingWrapper.style.display = total >= this.freeShippingThreshold ? 'flex' : 'none';
    }
  }

  customElements.define('shipping-date-component', ShippingDateComponent);
}
